import React, { useEffect, useState, useCallback } from "react";
import TrendsLineChart from "../lineChart/TrendsLineChart";
import dayjs from "dayjs";
import YAxisButtons from "./YAxisButtons";
import { useSelectedDateTimeFilter, useTimeFilterFrom, useTimeFilterTo } from "../../../hooks/useReduxSelectors";
import { Box } from "@mui/material";


const TrendChart = React.memo((props) => {
  const { chartData, chartIndex, chartLayout, isTrendLoading } = props;

  const isColumn = chartLayout === "column";

  const selectedDateTimeFilter = useSelectedDateTimeFilter();
  const timeFilterFrom = useTimeFilterFrom();
  const timeFilterTo = useTimeFilterTo();

  const [dateDomain, setDateDomain] = useState({});

  const getDomainForTimeAxis = useCallback(
    (type) => {
      const format = "DD-MM-YYYY HH:mm:ss";
      let now = dayjs().format(format);
      const lastHour = dayjs().subtract(1, "hour").format(format);
      let letdateDomain = {
        start: lastHour,
        end: now,
      };

      const calculateTimeRange = (type) => {
        let from = dayjs().subtract(Math.abs(timeFilterFrom), type).format(format);
        let to = dayjs().subtract(Math.abs(timeFilterTo), type).format(format);
        letdateDomain = {
          start: from,
          end: to,
        };
        return (letdateDomain);
      };

      if (type === "Live") {
        now = dayjs().format(format);
        const lastHalfHour = dayjs().subtract(30, "minute").format(format);
        letdateDomain = {
          start: lastHalfHour,
          end: now,
        };
      } else {
        letdateDomain = calculateTimeRange(type);
      }
      setDateDomain(letdateDomain);
    },
    [setDateDomain, timeFilterFrom, timeFilterTo]
  );


  useEffect(() => {
    if (selectedDateTimeFilter) {
      getDomainForTimeAxis(selectedDateTimeFilter);
    }
  }, [selectedDateTimeFilter, getDomainForTimeAxis, timeFilterFrom, timeFilterTo]);

  return (
    <Box sx={{
      display: "flex",
      flexDirection: "column",
      minWidth: 0,
      width: "100%",
      height: isColumn ? "50%" : "100%",
      minHeight: "500px",
      ...(isColumn && { minHeight: "350px" }),
    }}  >
      <YAxisButtons chartIndex={chartIndex} />
      <Box sx={{
        flex: "1 1 100%",
        minWidth: 0,
        minHeight: "350px",
        overflow: "hidden",
      }} >
        <TrendsLineChart chartData={chartData} dateDomain={dateDomain} chartIndex={chartIndex} isTrendLoading={isTrendLoading} />
      </Box>
    </Box >
  );
});

export default TrendChart;